import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { Quote } from './quote.model';

@Injectable({ providedIn: 'root' })

export class QuotesService extends BaseService<Quote>{
   
    constructor(
        protected injector: Injector,
    ){
        super(injector);

        this.copyJsonDataToObjectFunction=Quote.fromJsonToObject

        this.urls={getAllUrl:'quotes',saveUrl:'regQuota',updateUrl:'up-quota',deleteUrl:'dst-quota'}
    }

}